import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import Live from "@/pages/live/page";
import MatchDetail from "@/pages/match/page";
import TeamDetail from "@/pages/team/page";
import Schedule from "@/pages/schedule/page";
import News from "@/pages/news/page";
import NewsDetail from "@/pages/news/detail/page";
import About from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "live",
        element: <Live />,
      },
      {
        path: "match/:id",
        element: <MatchDetail />,
      },
      {
        path: "team/:id",
        element: <TeamDetail />,
      },
      {
        path: "schedule",
        element: <Schedule />,
      },
      {
        path: "news",
        element: <News />,
      },
      {
        path: "news/:id",
        element: <NewsDetail />,
      },
      {
        path: "about",
        element: <About />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;